<template>
  <div class="authentication-wrapper vh-center-content full-height">
    <img src="../../assets/images/logo.png" alt="" />
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Authentication"
};
</script>

<style></style>
